// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (emergenciesstatus-edit e emergenciesstatus-list)

import { Injectable } from '@angular/core';
import { Emergenciesstatus } from './emergenciesstatus.model';
import { Subject } from 'rxjs';

@Injectable()
export class EmergenciesstatusService {
  private emergenciesstatus: Emergenciesstatus[] = [];
  emergenciesstatusChanged = new Subject<Emergenciesstatus[]>();
  emergenciesstatusEditMode = new Subject<number>();
  emergenciesstatuscountChanged = new Subject<string>();
  private emergenciesstatuscount: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getEmergenciesstatus() {
    return this.emergenciesstatus;
  }
  getEmergenciesstatuscount() {
    return this.emergenciesstatuscount;
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setEmergenciesstatus(emergenciesstatus: Emergenciesstatus[]) {
    if (emergenciesstatus !== null) {
      this.emergenciesstatus = emergenciesstatus;
      if (this.emergenciesstatus) this.emergenciesstatusChanged.next(this.emergenciesstatus.slice()); else this.emergenciesstatusChanged.next([])
    }
  }

  setEmergenciesstatuscount(emergenciesstatuscount: string) {
    if (emergenciesstatuscount !== null) {
      this.emergenciesstatuscount = emergenciesstatuscount;
      this.emergenciesstatuscountChanged.next(this.emergenciesstatuscount.slice());
    }
  } 
}
